const isZeroValueString = (v) => /^0[^.\s]+$/u.test(v);
export {
  isZeroValueString
};
